import { Component, OnInit } from '@angular/core';
import { SessionService } from '../services/session.service';
import { Router } from '@angular/router';
import { ThemeManagerService } from '../services/theme-manager.service';

@Component({
  selector: 'cw-ci-unsecure-welcome',
  template: ''
})
export class HomeLandingComponent implements OnInit {
  constructor(private _sessionService: SessionService, private _router: Router, public themeManager: ThemeManagerService) {
  }

  ngOnInit() {
    this._sessionService.isAuthenticated().then(isLoggedIn => {
      if (!isLoggedIn) {
        console.log('User is not authenticated. Routing to login.');
        this._router.navigate(['/public/login']);
      } else {
        console.log('User is authenticated. Routing to secure paged.');
        this._router.navigate(['/secured']);
      }
    }).catch(
      err => {
        console.error('Error checking authentication', err);
        this._router.navigate(['/public/login']);
      }
    );
  }
}

@Component({
  selector: 'cw-ci-unsecure-home',
  templateUrl: './home.component.layout.html',
  styleUrls: ['./home.component.layout.scss']
})
export class HomeComponent implements OnInit {

  constructor(public themeManager: ThemeManagerService) { }

  ngOnInit() {
  }

}